/*
 * @Author: limingshuang limingshuang@yunhdkc.com
 * @Date: 2025-02-20 11:53:36
 * @LastEditors: limingshuang limingshuang@yunhdkc.com
 * @LastEditTime: 2025-04-24 15:59:38
 * @FilePath: \dyt_html_v2.0\src\apis\ask2Api\im.js
 * @Description: im-能力API
 */
import service from './base'

  /**
   * @description: 创建im用户
   * @return {*}
   */
  export function createIMUserApi(data) {
    return service({
      url: `/ask/customer/api/v1/im/user/create`,
      method: 'POST',
      data
    })
  }
  /**
   * @description: 获取im用户信息
   * @return {*}
   */
  export function getIMUserInfoApi(data) {
    return service({
      url: `/ask/customer/api/v1/im/user/profile/query`,
      method: 'POST',
      data
    })
  }

  /**
   * @description: 获取im用户签名
   * @return {*}
   */
  export function getIMUserSignApi(data) {
    return service({
      url: `/ask/customer/api/v1/im/user-sig`,
      method: 'get',
      params: data
    })
  }
  /**
   * @description: 发送消息
   * @param {*} data
   * @return {*}
   */
  export function setMessageApi(data) {
    return service({
      url: `/ask/customer/api/v1/im/message/group/send-message`,
      method: 'POST',
      data
    })
  }
  /**
   * @description: 获取消息列表
   * @param {*} data
   * @return {*}
   */
  export function getMessageListApi(data) {
    return service({
      url: `/ask/customer/api/v1/im/message/group/select-message-history`,
      method: 'POST',
      data
    })
  }
  /**
   * @description: 设置消息已读
   * @param {*} data
   * @return {*}
   */
  export function readMessage(data) {
    return service({
      url: `/ask/customer/api/v1/im/read-message`,
      method: 'POST',
      data
    })
  }
  /**
   * @description: 修改电话问诊用户手机号
   * @param {*} data
   * @return {*}
  */
  export function updatePatientPhoneApi(data) {
    return service({
      url: `/ask/patient/api/v1/contact-info/update-patient-phone`,
      method: 'GET',
      params:data
    })
  }
  /**
   * @description: 查询和当前医生的历史聊天群组消
   * @param {*} data
   * @return {*}
  */
  export function getContactListApi(data) {
    return service({
      url: `/ask/patient/api/v1/contact-info/get-contact-list`,
      method: 'POST',
      data
    })
  }

